import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentConfigInterface, PE_ENV } from '@pe/common/core';

import { ShippingAddressInterface, ShippingResponseInterface, ShippingCartProduct } from '../types';

@Injectable()
export class ShippingApiService {
  constructor(
    @Inject(PE_ENV) private env: EnvironmentConfigInterface,
    private httpClient: HttpClient
  ) {
  }

  attachShipping(channelSetId: string, shippingOrderId: string, integrationSubscriptionId: string): Observable<object> {
    return this.httpClient.post<object>(`${this.env.backend.shipping}/api/channel-set/${channelSetId}/shipping/select-method`, {
      shippingOrderId,
      integrationSubscriptionId,
    });
  }

  requestShippingData(
    channelSetId: string,
    address: ShippingAddressInterface,
    products: ShippingCartProduct[],
  ): Observable<ShippingResponseInterface> {
    return this.httpClient.post<ShippingResponseInterface>(
      `${this.env.backend.shipping}/api/channel-set/${channelSetId}/shipping/methods`,
      {
        shippingAddress: address,
        shippingItems: products,
      }
    );
    /* // TODO Remove
    return of({
      "shippingOrderId": "ade63d9b-4dbe-4d9b-b082-6b70d1d79c26",
      "methods": [
        {
          "integrationSubscriptionId": "507875cb-102f-47a6-9845-ebbfbada5648",
          "integrationRule": {
            "isActive": true,
            "_id": "f7e67897-0f1b-4a5b-ac84-e05cea9f0034",
            "type": {
              "_id": "71e689f2-a185-11e9-a252-1fc0734f1106",
              "name": "freeOver",
              "title": "shipping.rule.freeOver",
              "isExtendable": true,
              "isCompatible": true,
              "createdAt": "2019-02-11T09:30:00.340Z",
              "updatedAt": "2019-02-11T09:30:00.340Z",
              "__v": 0
            },
            "freeOver": 501,
            "rate": 0,
            "weightRanges": [],
            "rateRanges": []
          },
          "rate": 0
        }
      ]
    });*/
  }
}
